import React from 'react'
import './index.css'

const ExplainerBox = () => {
    // add a tooltip to the icon
    return (
        <div className='explainer-container'>
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#323232" stroke-width="2" />
                <path d="M10.5 8.67709C10.8665 8.26188 11.4027 8 12 8C13.1046 8 14 8.89543 14 10C14 10.9337 13.3601 11.718 12.4949 11.9383C12.2273 12.0064 12 12.2239 12 12.5V12.5V13" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 16H12.01" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div className="explainer-box">
                {/* <div className="explainer-box-title">What is this?</div> */}
                <div className="explainer-box-body">
                    You won't be charged for a listing being displayed on Shabbos.
                </div>
            </div>
        </div>
    )
}

export default ExplainerBox